export enum recordTypes {
    MAKE_A_COPY = 1, // 生成副本
    EXPORT_TO_LOCAL = 2, // 导出到本地
    LIFE_GROWTH_CHART = 3, // 生成长图
    SAVE_AS_MY_TEMPLATE = 4, // 保存为我的模板
    PRINT_A_DOCUMENT = 5, // 打印文档,
    COPY_FULL_TEXT = 6, // 复制全文
    IMPORT_DOCUMENTS = 7, // 导入文档
    NEW_DOCUMENT = 8, // 新建文档
    IMPORT_THROUGH_DRIVE = 9, // 通过 drive 导入
    REPLICA_CREATION = 10, // 副本创建
    TEMPLATE_CREATION = 11, // 模板创建
    EXPORT_TO_DRIVE = 12, // 导出到 drive
}

export enum fileTypes {
    UNKNOWN = 0,
    PPT = 1,
    WORD = 2,
    EXCEL = 3,
    TXT = 4,
    PDF = 5
}
